export default __webpack_public_path__ + "static/media/Facebook.18b1a3e9.svg";